import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import RequiredIndicator from './required-indicator';
import { TooltipDisplay } from './tooltip-display';
import styleable from 'react-styleable';
import defaultStyle from './common.style.js';

export class RequiredLabel extends Component {
  render() {
    const { hasErrors, tooltip, isRequired, content, htmlFor, css } = this.props;

    return(
      <div>
        <label className={css.requiredLabel} aria-label={content} htmlFor={htmlFor}>
          {hasErrors ? <span id="error-icon" className={css.errorIndicator} aria-hidden='true'/> : null}
          {content}
        </label>
        { tooltip ? <TooltipDisplay text={tooltip} context={content}/> : null}
        <RequiredIndicator css={css} isRequired={isRequired}/>
      </div>
    );
  }
}

RequiredLabel.defaultProps = {
  isRequired: false
};

RequiredLabel.propTypes = {
  hasErrors: PropTypes.bool,
  htmlFor: PropTypes.string,
  content: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  isRequired: PropTypes.bool
};

export default styleable(defaultStyle) (RequiredLabel);



// WEBPACK FOOTER //
// src/common/required-label.js